// 引导式打包vuex
const guidedPack = {
  state: {
    packStatus: 0, // 0 基础信息输入阶段，1 复核打包，2 独立打包
    packSteps: 'packMachineNo', // packMachineNo 打包台，shippingContainerNo 发货容器号，containerNo 拣货容器号
    packTypeGuided: 0, // 1 复核打包 2 独立打包
    obCheckCM_V2: {}, // 复核打包返回
    checkMR_V2: {}, // 独立打包返回
    containerNoGuided: '', // 拣货容器号/rebin墙号
    packMachineNoGuided: '', // 工作台号
    shippingContainerNoGuided: '',// 发货容器号
    showConsCodeInputGuided: false, // 是否展示耗材输入框
    shippingContainerNoFlagGuided: false, // 发货容器号开关
    packMachineFlagGuided: '',  // 打包机标识
    handInputFlag: '', // 手动输入
    lastPackInfoGuided: { so: '', operator: '' }, // 上一个打包信息（出库单号 + 操作员）
    isFullScreenGuided: false, // 全屏状态
  },
  getters: {
    packStatus: state => state.packStatus,
    packSteps: state => state.packSteps,
    packTypeGuided: state => state.packTypeGuided,  
    obCheckCM_V2: state => state.obCheckCM_V2,
    checkMR_V2: state => state.checkMR_V2,
    containerNoGuided: state => state.containerNoGuided,
    packMachineNoGuided: state => state.packMachineNoGuided,
    shippingContainerNoGuided: state => state.shippingContainerNoGuided,
    showConsCodeInputGuided: state => state.showConsCodeInputGuided,
    shippingContainerNoFlagGuided: state => state.shippingContainerNoFlagGuided,
    packMachineFlagGuided: state => state.packMachineFlagGuided,
    handInputFlag: state => state.handInputFlag,
    lastPackInfoGuided: state => state.lastPackInfoGuided,
    isFullScreenGuided: state => state.isFullScreenGuided,
  },
  mutations: {
    SET_HAND_INPUT_FLAG(state, payload) {
      state.handInputFlag = payload
    },
    SET_PACK_STATUS(state, payload) {
      state.packStatus = payload
    },
    SET_PACK_STEPS(state, payload) {
      state.packSteps = payload
    },
    SET_PACKAGE_TYPE_GUIDED(state, payload) {
      state.packTypeGuided = payload
    },
    SET_OB_CHECK_CM_V2(state, payload) {
      state.obCheckCM_V2 = payload
    },
    SET_CHECK_MR_V2(state, payload) {
      state.checkMR_V2 = payload
    },
    SET_CONTAINER_NO_GUIDED(state, payload) {
      state.containerNoGuided = payload
    },
    SET_PACK_MACHINE_NO_GUIDED(state, payload) {
      state.packMachineNoGuided = payload
    },
    SET_SHIP_CONTAINER_NO_GUIDED(state, payload) {
      state.shippingContainerNoGuided = payload
    },
    SET_CONS_CODE_INPUT_SHOW_GUIDED(state, payload) {
      state.showConsCodeInputGuided = payload
    },
    SET_SHIPPING_CONTAINER_NO_FLAG_GUIDED(state, payload) {
      state.shippingContainerNoFlagGuided = payload
    },
    SET_BIND_PACK_MACHINE(state, payload) {
      state.packMachineFlagGuided = String(payload)
    },
    SET_LAST_PACK_INFO_GUIDED(state, payload) {
      state.lastPackInfoGuided = payload
    },
    SET_IS_FULL_SCREEN_GUIDED(state, payload) {
      state.isFullScreenGuided = payload
    },
  }
}

export default guidedPack
